import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
export default {
    apiGetPDPAVersion: function() {
        const bzbConfig = Vue.bzbsConfig;
        const appId = bzbConfig.client_id;
        const url = bzbConfig.bzbsBlobUrl + `/pdpaconsent/${appId}/version`;
        return new Promise((resolve,reject) =>{
            BzbsApi.connectBzbsGetBlob(url).then(response => {
                resolve(response)
            }).catch((error) => {
                reject(error);
            });
        })
    },
    apiGetPDPAContent: function(contentType, version, language) {
        const bzbConfig = Vue.bzbsConfig;
        const appId = bzbConfig.client_id;
        const url = bzbConfig.bzbsBlobUrl  + `/pdpaconsent/${appId}/${contentType}/${version}/${language}.txt`;
        return new Promise((resolve,reject) =>{
            BzbsApi.connectBzbsGetBlob(url).then(response => {
                resolve(response)
            }).catch((error) => {
                reject(error);
            });
        })
    },
}
